var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"type":_vm.type,"label":_vm.label,"rules":_vm.rules,"value":_vm.value ? _vm.value : '',"prefix":_vm.prefix,"min":"0"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})}
var staticRenderFns = []

export { render, staticRenderFns }